export default {
    protocolosEntrega: [],
    protocoloEntrega: {},
    ultimaAtualizacaoListaProtocoloEntrega: Date
}